import {Nullable} from '../../app/TypeHelpers'

export default class NewEquipment {
    name: string
    explainText: string
    parentEquipmentId: Nullable<number>
    reservationCountMonthly: Nullable<number>
    reservationCountDaily: Nullable<number>
    lotteryEntryCountMonthly: Nullable<number>

    constructor(
        name: string,
        explainText: string,
        parentEquipmentId: Nullable<number>,
        reservationCountMonthly: Nullable<number>,
        reservationCountDaily: Nullable<number>,
        lotteryEntryCountMonthly: Nullable<number>,
    ) {
        this.name = name
        this.explainText = explainText
        this.parentEquipmentId = parentEquipmentId
        this.reservationCountMonthly = reservationCountMonthly
        this.reservationCountDaily = reservationCountDaily
        this.lotteryEntryCountMonthly = lotteryEntryCountMonthly
    }
}
